import { FilespaceSettingsResponseDto, } from '@lucidlink/dto/web-service-api';
import { parserFromDto } from '#fetcher/parse-utils';
export const createGeneralSettingManager = (filespaceFetcher) => {
    return new GeneralSettingManagerImpl(filespaceFetcher);
};
class GeneralSettingManagerImpl {
    filespaceFetcher;
    constructor(filespaceFetcher) {
        this.filespaceFetcher = filespaceFetcher;
    }
    setSettings(settings) {
        return this.filespaceFetcher.patch('settings', {
            body: { ...settings },
            parser: parserFromDto(FilespaceSettingsResponseDto),
        });
    }
    getSettings() {
        return this.filespaceFetcher.get('settings', {
            parser: parserFromDto(FilespaceSettingsResponseDto),
        });
    }
}
